<script>
  import { questionsWrite, settings, statistics } from "./store.js";
  import { getQuestions, setSettings} from "./functions.js";

  import QuizView from "./QuizView.svelte";
  import QuizRun from "./QuizRun.svelte";

  let initSettings = setSettings();
  prepareQuiz(initSettings);
  settings.set(initSettings);

  //$: console.log($questionsWrite);
  //$: console.log($settings);
  //$: console.log($statistics);
  //$: console.log($questionsRead);

  function prepareQuiz(settings) {
    questionsWrite.set(getQuestions(settings));
  }

  function handleQuizStart(event) {
    $settings.quiz = true;
    prepareQuiz($settings);
  }

  function handleQuizClose(event) {
    $settings.quiz = false;
    prepareQuiz($settings);
  }

  function handleQuizRotate(event) {
    prepareQuiz($settings);
  }
</script>

<style></style>

<QuizView on:quizStart={handleQuizStart} on:quizRotate={handleQuizRotate} />

<QuizRun  on:quizClose={handleQuizClose} />
